var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdultMarkLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/filled/adult"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4421 8C14.4421 4.44212 11.5579 1.55789 8 1.55789C4.44212 1.55789 1.55789 4.44212 1.55789 8C1.5579 11.5579 4.44212 14.4421 8 14.4421C11.5579 14.4421 14.4421 11.5579 14.4421 8ZM8 0C12.4183 -4.06588e-08 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 9.17363e-07 12.4183 0 8C-9.17363e-07 3.58172 3.58172 4.06588e-08 8 0Z",
    fill: "#EC2A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89371 4.6667C11.234 4.67304 12.5046 5.47151 12.5109 7.82891C12.5141 10.0374 11.4653 11.3333 9.83984 11.3333C8.53123 11.3333 7.6377 10.5158 7.50462 9.41953H8.83224C8.94314 9.89481 9.31386 10.1768 9.83984 10.1768C10.7175 10.1768 11.1865 9.38467 11.1928 8.0919H11.1326C10.8316 8.66224 10.1916 9.00445 9.47229 9.00445C8.30626 9.00445 7.44125 8.12676 7.43808 6.91637C7.43491 5.61093 8.4235 4.66036 9.89371 4.6667ZM8.74986 6.87835C8.75303 7.52156 9.22514 8.01903 9.89054 8.01903C10.5464 8.01903 11.0534 7.49622 11.0502 6.87201C11.0471 6.25414 10.5623 5.72816 9.90005 5.72816C9.23465 5.72816 8.74352 6.23513 8.74986 6.87835Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3317 4.75572V11.2449H4.9819V6.03899H4.94387L3.45465 6.97371V5.776L5.06111 4.75572H6.3317Z",
    fill: "#121212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultMarkLight);
export default __webpack_public_path__ + "static/media/adult_mark_light.57413d313588f399fe22840a4a3d48d1.svg";
export { ForwardRef as ReactComponent };